module.exports = __webpack_public_path__ + "static/media/arrow_icon.ba736df0.svg";